var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ direction: _vm.$vs.rtl ? 'rtl' : 'ltr' })},[(
      _vm.$route.name == 'list-cascade-fields')?_c('feather-icon',{attrs:{"icon":"EditIcon","svgClasses":"mr-3 h-5 w-5 hover:text-danger cursor-pointer"},on:{"click":_vm.updateCampaignCascadedFields}}):_vm._e(),(
      _vm.$route.name == 'list-cascade-fields')?_c('feather-icon',{attrs:{"icon":"TrashIcon","svgClasses":"mr-3 h-5 w-5 hover:text-danger cursor-pointer"},on:{"click":_vm.deleteCampaignCascadedFields}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }